import { parseQueryString } from 'src/utils/browser';

export const getLoginType = () => {
  let loginType = 'normal';
  if (window.location.href.indexOf('sso') > -1) {
    loginType = 'sso';
  }
  return loginType;
};

export const getSSOReferrer = (): {
  referrer?: string;
  redirectUrl?: string;
} => {
  if (getLoginType() === 'sso') {
    const { referrer } = parseQueryString();
    const storedReferrer = localStorage.getItem('x-sl-sso-signin-referrer');
    return {
      referrer: (referrer as string) || storedReferrer || 'gitbook',
      redirectUrl: localStorage.getItem('x-sl-sso-signin-redirect-url') || ''
    };
  }
  return {
    referrer: undefined,
    redirectUrl: undefined
  };
};

export const saveSSOReferrer = () => {
  if (getLoginType() === 'sso') {
    const { referrer, location } = parseQueryString();
    const storedReferrer = localStorage.getItem('x-sl-sso-signin-referrer');
    const storedRedirectUrl = localStorage.getItem('x-sl-sso-signin-redirect-url');
    localStorage.setItem('x-sl-sso-signin-referrer', (referrer as string) || storedReferrer || 'gitbook');
    localStorage.setItem('x-sl-sso-signin-redirect-url', (location as string) || storedRedirectUrl || '');
  } else {
    localStorage.removeItem('x-sl-sso-signin-referrer');
    localStorage.removeItem('x-sl-sso-signin-redirect-url');
  }
};

export const handleSSORedirect = (jwtToken: string) => {
  // Skip redirect on sign-out
  if (window.location.href.includes('/sign_out')) {
    return;
  }

  const { referrer, redirectUrl: location } = getSSOReferrer();
  console.log('sso location', location);

  // Map referrers to base URLs
  // Format: {appName} for prod, {appName}-{stage} for non-prod
  const referrerMap: Record<string, string> = {
    // Atlas
    'atlas': 'https://atlas.stackline.com',
    'atlas-dev': 'https://atlas-dev.stackline.com',
    'atlas-localhost': 'https://atlas-localhost.stackline.com',
    
    // Beacon
    'beacon': 'https://beacon.stackline.com',
    'beacon-dev': 'https://beacon-dev.stackline.com',
    'beacon-localhost': 'https://beacon-localhost.stackline.com',
    
    // Advisor (zenith hostnames redirect to advisor URLs)
    'advisor': 'https://advisor.stackline.com',
    'advisor-dev': 'https://advisor-dev.stackline.com',
    'advisor-localhost': 'https://zenith-localhost.stackline.com',
    'advisor-alpha': 'https://advisor-alpha.stackline.com',
    
    // Omni
    'omni': 'https://omni.stackline.com',
    'omni-dev': 'https://omni-dev.stackline.com',
    'omni-localhost': 'https://omni-localhost.stackline.com',
    
    // Advertising (ad/drive)
    'ad': 'https://ad.stackline.com',
    'ad-dev': 'https://ad-dev.stackline.com',
    'ad-localhost': 'https://ad-localhost.stackline.com',
    
    // Legacy/other referrers
    'gitbook': 'https://enterprise-help.stackline.com',
    'stackline-support-portal': 'https://enterprise-help.stackline.com',
    'atlas-llm': 'https://atlas-llm.stackline.com',
    'atlas-llm-localhost': 'https://atlas-llm-localhost.stackline.com',
    'zenith': 'https://zenith.stackline.com',
    'zenith-localhost': 'https://zenith-localhost.stackline.com',
    'zenith-dev': 'https://zenith-dev.stackline.com',
  };

  const baseUrl = referrerMap[referrer];
  if (!baseUrl) {
    throw new Error('Invalid SSO referrer');
  }

  const targetPath = location ? decodeURIComponent(location) : '';
  // Remove leading slash from targetPath to avoid double slashes
  const cleanPath = targetPath.startsWith('/') ? targetPath.slice(1) : targetPath;
  const redirectUrl = `${baseUrl}/${cleanPath}?jwt_token=${jwtToken}`;

  // Clear the persisted referrer now that login is complete. This prevents
  // a stale referrer from showing the wrong logo on a future direct visit to
  // enterprise-sso without a ?referrer param.
  localStorage.removeItem('x-sl-sso-signin-referrer');
  localStorage.removeItem('x-sl-sso-signin-redirect-url');

  window.location.href = redirectUrl;
};
